import { render, staticRenderFns } from "./Stakes.vue?vue&type=template&id=12674a7b&"
import script from "./Stakes.vue?vue&type=script&lang=js&"
export * from "./Stakes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports